import * as React from 'react'
import { compose, pure } from 'recompose'

import * as styles from './OuterLink.css'

export enum OuterLinkType {
  NORMAL = 'normal',
  RED = 'red',
  RED_BORDER = 'redBorder',
  ACCENT_BUTTON = 'accentButton'
}

interface OuterLinkProps {
  to: string
  type: OuterLinkType
  children: any
}

const OuterLink: React.FunctionComponent<OuterLinkProps> = ({ to, type, children }) => {
  return (
    <div className={styles[type]}>
      <a href={to} className={styles.text} target="_blank">
        {children}
      </a>
    </div>
  )
}

export default compose<OuterLinkProps, OuterLinkProps>(pure)(OuterLink)
